module.exports = __webpack_public_path__ + "static/media/resources-mobile-bg.b934e386.jpg";